import { useState } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import Comission from 'services/Comission'
import Payment from 'services/Payment'
import DeleteBillDialog from 'components/DeleteBillDialog'
import { FaEdit, FaEye, FaTrash } from 'react-icons/fa'
import { ReactComponent as ButtonLoading } from 'icons/loading2.svg'
import { DateTime } from 'luxon'

import {
  Container,
  Row,
  InfoText,
  MoneyTextMask,
  Button
} from './styles'

export default function BusinessBill ({
  data: bill,
  showComissions = false,
  type = null,
  category = null,
  professionalID = null,
  paymentMethod = null,
  cardFlag = null,
  bankAccount = null,
  onEdit = () => {},
  onDelete: handleDelete = () => {}
}) {
  const [deleting, setDeleting] = useState (false)
  const [showDeleteDialog, setShowDeleteDialog] = useState (false)
  const hasOpenBillEditPermission = AuthService.hasPermission ('financial.open_bills', 'edit') && bill.open
  const hasOpenBillDeletePermission = AuthService.hasPermission ('financial.open_bills', 'delete') && bill.open
  const hasClosedBillEditPermission = AuthService.hasPermission ('financial.closed_bills', 'edit') && !bill.open
  const hasClosedBillDeletePermission = AuthService.hasPermission ('financial.closed_bills', 'delete') && !bill.open
  const paymentsValue = bill.payments.reduce ((total, payment) => total + payment.value, 0)
  const itemsValue = bill.value
  const token = AuthService.getToken ()
  const user = AuthService.getUser ()
  
  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const handleEdit = () => onEdit (bill)
  const toggleDeleteDialog = () => setShowDeleteDialog (!showDeleteDialog)

  const deleteBill = async deleteReason => {
    setDeleting (true)
    try {
      await cutileiApi.delete (
        `/business_bills/${bill.id}?delete_reason=${deleteReason}`, requestConfig
      )
      setDeleting (false)
      handleDelete (bill)
    } catch (error) {
      setDeleting (false)
      logApiError (error)
    }
  }

  return (
    <Container showComissions={showComissions}>
      <InfoText>
        Nº{bill.number} ({DateTime.fromISO (bill.date).toFormat ('dd/MM/yyyy')})
      </InfoText>
      <InfoText>
        {bill.customer?.name}
      </InfoText>
      <InfoText>
        {`${bill?.cash_register.opened_by?.name ?? user.name} ` }
        ({DateTime.fromISO (bill.cash_register.created_at).toFormat ('dd/MM/yyyy - HH:mm:ss')})
      </InfoText>
      <InfoText>
        {DateTime.fromISO (bill.created_at).toFormat ('dd/MM/yyyy - HH:mm:ss')}
      </InfoText>
      {!!professionalID ? (
        <MoneyTextMask value={
          Comission.getTotalEarnings ([bill], type, category, { id: professionalID })
        }/>
      ) : (
        <MoneyTextMask value={
          paymentMethod 
            ? Payment.getTotalValueByPaymentMethod (bill.payments, paymentMethod, cardFlag, bankAccount)
            : bill.open ? itemsValue : paymentsValue
        }/>
      )}
      {showComissions && type && (
        <MoneyTextMask value={Comission.getProfessionalEarnings ([bill], type, category)}/>
      )}
      <Row>
        {(hasOpenBillEditPermission || hasClosedBillEditPermission) && (
          <Button onClick={handleEdit}>
            {bill.open ? (
              <FaEdit color='#35A7FF' size={18}/>
            ) : (
              <FaEye color='#35A7FF' size={18}/>
            )}
          </Button>
        )}
        {(hasOpenBillDeletePermission || hasClosedBillDeletePermission) && (
          <Button onClick={toggleDeleteDialog}>
            {deleting ? (
              <ButtonLoading style={{margin: 0}}/>
            ) : (
              <FaTrash color='#FF3939' size={16}/>
            )}
          </Button>
        )}
      </Row>
      <DeleteBillDialog
        visible={showDeleteDialog}
        title='Atenção!'
        onConfirm={deleteBill}
        onClose={toggleDeleteDialog}
      />
    </Container>
  )
}
